import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Typography,
  Slide,
  Link
} from "@mui/material";
import {
  VisibilityOffOutlined,
  VisibilityOutlined,
  BusinessCenterOutlined,
} from "@mui/icons-material";
import ErrorIcon from "@mui/icons-material/Error";

const CorporateDialog = ({ isCorporateDialogOpen, closeCorporatePopup }) => {
  return (
    <Dialog
      open={isCorporateDialogOpen}
      onClose={closeCorporatePopup}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          padding: "20px",
          maxWidth: "500px",
        },
      }}
      TransitionComponent={Slide}
      TransitionProps={{ direction: "up", timeout: 500 }}
    >
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: 0,
        }}
      >
        <BusinessCenterOutlined
          sx={{ width: "40px", height: "40px", color: "#003D78" }}
        />
        <DialogTitle
          sx={{
            color: "#003D78",
            fontWeight: "bold",
            fontSize: "24px",
            marginTop: "16px",
            textAlign: "center",
          }}
        >
          Corporate Access Only
        </DialogTitle>
        <Typography
          variant="body1"
          gutterBottom
          textAlign="center"
          sx={{ fontSize: "16px", marginTop: "8px", color: "#333" }}
        >
          We are currently offering corporate packages to access our platform.
        </Typography>
        <Typography
          variant="body2"
          textAlign="center"
          sx={{
            color: "#555",
            fontSize: "14px",
            marginTop: "14px",
            textAlign: "center",
          }}
        >
          Please contact us at{" "}
          <Link
            href="mailto:support@lawgpt.pk"
            sx={{ color: "#003D78", fontWeight: "bold" }}
          >
            support@lawgpt.pk
          </Link>{" "}
          to get access to the platform.
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "center",
          marginTop: "16px",
        }}
      >
        <Button
          onClick={closeCorporatePopup}
          variant="contained"
          sx={{
            bgcolor: "#003D78",
            textTransform: "none",
            padding: "10px 24px",
            borderRadius: "8px",
            "&:hover": {
              bgcolor: "#002F60",
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CorporateDialog;
